import React from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * The "Swipe up to open" pill that sits on top of the mini-map when
 * the map is collapsed. Owns nothing — parent wires the pointer
 * handlers so the drag gesture stays coordinated with `useGuestMapDrag`.
 */
export function MapDragHandle({ onPointerDown, onPointerMove, onPointerUp }) {
  return (
    <div
      data-testid="map-drag-handle"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      style={{
        position: 'absolute',
        top: 10,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '6px 13px',
        borderRadius: 999,
        background: 'rgba(10, 10, 16, 0.42)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        color: '#FFFFFF',
        fontFamily: "'Inria Serif', serif",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
        cursor: 'grab',
        touchAction: 'none',
        userSelect: 'none',
        zIndex: 24,
      }}
    >
      <ChevronUp size={13} strokeWidth={2.4} />
      <span>Swipe up to open</span>
    </div>
  );
}
